export default __webpack_public_path__ + "static/media/logomicyda.8a997b49.png";